import config from "@config"
import logoImg from "@images/2x/1aa.png"
import btn2021Img from "@images/2x/2aa.png"
import sponsorImg from "@images/2x/36aa.png"
import btnReviewImg from "@images/2x/3aa.png"
import lottieJson from "@images/lottie/booom_bg_motion.json"
import Button from "@src/components/button"
import Clickable from "@src/components/clickable"
import LottieControl from "@src/components/lottie"
import classnames from "@src/utils/classnames"
import React from "react"
import * as styles from "./header.module.scss"

const Header = React.memo((props) => {
  return (
    <div className={styles.container}>
      <div className={styles.head}>
        <div className={styles.svg}>
          <LottieControl
            className={styles.lottie}
            animationData={lottieJson}
            config={{ renderer: "svg" }}
          />
        </div>
        <img src={logoImg} className={styles.logo} alt="logo" />
      </div>
      <div className={classnames("intro", styles.intro)}>
        <div className={classnames("intro_body", styles.introBody)}>
          <h2>
            BOOOM 2022
            <br />
            游戏创作挑战
            <br />
            <Button
              style={{ fontSize: "18px", marginTop: "10px" }}
              appNavTo={config.links.enroll}
              disabled
            >
              报名结束
            </Button>
          </h2>
          <div>
            <p>
              BOOOM CHALLENGE 游戏创作挑战（以下简称
              BOOOM），是由机核网举办的限时、限主题游戏创作活动。
            </p>
            <p>
              只要你对游戏创作感兴趣，BOOOM
              欢迎你的加入～你可以是擅长或具有一定视觉表达、声音编辑、游戏开发能力的人，也可以是没有专长但是点子特别多的人，我们相信让具有创造能力的人们聚在一起，会产生仿佛化学反应一般的有机碰撞
              BOOOM！
            </p>
            <p className={styles.btns}>
              <Clickable
                appNavTo={config.links.event2021}
                className="img-btn mr-3"
              >
                <img src={btn2021Img} alt="2021" />
              </Clickable>
              <Clickable
                appNavTo={config.links.event2021Review}
                className="img-btn"
              >
                <img src={btnReviewImg} alt="2021 review" />
              </Clickable>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
})

Header.displayName = "header"
export default Header
